<template>
  <div class="carousel-container">
    <el-card>
      <div class="card-header">
        <el-button type="primary" @click="openAddDialog">添加轮播图</el-button>
      </div>
      <el-table :data="carouselList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="image" label="轮2播图" width="150">
          <template slot-scope="scope">
            <el-image :src="scope.row.image" fit="cover" style="width: 100px; height: 50px;"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="url" label="跳转链接"></el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="small" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加/编辑轮播图对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="carouselForm" :rules="carouselRules" ref="carouselForm" label-width="80px">
        <el-form-item label="轮播图" prop="image">
          <el-upload
            class="avatar-uploader"
            :auto-upload="false"
            :on-change="handleImageChange"
            :show-file-list="false"
            :before-upload="beforeImageUpload"
          >
            <img v-if="carouselForm.imageUrl" :src="carouselForm.imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="跳转链接" prop="url">
          <el-input v-model="carouselForm.url" placeholder="请输入跳转链接"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="carouselForm.sort" :min="1" :max="999" placeholder="请输入排序值"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCarouselForm('carouselForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  data() {
    return {
      carouselList: [],
      dialogVisible: false,
      dialogTitle: '添加轮播图',
      carouselForm: {
        id: '',
        image: null,  // 存储图片文件对象
        imageUrl: '', // 存储图片URL用于显示
        url: '',
        sort: 1
      },
      carouselRules: {
        image: [
          { required: true, message: '请上传轮播图', trigger: 'change' }
        ],
        url: [
          { required: true, message: '请输入跳转链接', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序值', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadCarouselList()
  },
  methods: {
    loadCarouselList() {
      this.$http.get('/chuanmei/carousel')
        .then(response => {
          if (response.data.success) {
            this.carouselList = response.data.data.map(item => {
              console.log('http://quanyutui.ccdcamera.site' +item.image)
              return {
                id: item.id,
                image: 'http://quanyutui.ccdcamera.site' +item.image,
                url: item.url,
                sort: item.sort,
                create_time: item.create_time,
                createTime: new Date(item.create_time).toLocaleString()
              }
            })
          } else {
            this.$message.error('获取轮播图列表失败')
          }
        })
        .catch(error => {
          console.error('获取轮播图列表失败:', error)
          this.$message.error('获取轮播图列表失败，请稍后重试')
        })
    },
    openAddDialog() {
      this.dialogTitle = '添加轮播图'
      this.carouselForm = {
        id: '',
        image: null,
        imageUrl: '',
        url: '',
        sort: 1
      }
      this.dialogVisible = true
    },
    openEditDialog(row) {
      this.dialogTitle = '编辑轮播图'
      this.carouselForm = JSON.parse(JSON.stringify(row))
      this.carouselForm.imageUrl = row.image  // 设置图片URL用于显示
      this.carouselForm.image = null  // 初始化为null，只有在重新选择图片时才会有值
      this.dialogVisible = true
    },
    handleImageChange(file, fileList) {
      // 当用户选择图片后，保存文件对象并显示预览
      this.carouselForm.image = file.raw
      this.carouselForm.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeImageUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isImage && isLt2M
    },
    submitCarouselForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const formData = new FormData()
          formData.append('url', this.carouselForm.url)
          formData.append('sort', this.carouselForm.sort)
          
          // 如果有新选择的图片文件，则添加到formData中
          if (this.carouselForm.image) {
            formData.append('image', this.carouselForm.image)
          } else {
            // 编辑时，如果没有选择新图片，则使用原图片URL
            formData.append('image', this.carouselForm.imageUrl)
          }

          if (this.carouselForm.id) {
            // 编辑轮播图
            this.$http.put(`/chuanmei/carousel/${this.carouselForm.id}`, formData)
              .then(response => {
                if (response.data.success) {
                  this.$message.success('编辑成功')
                  this.dialogVisible = false
                  this.loadCarouselList()
                } else {
                  this.$message.error(response.data.message || '编辑失败')
                }
              })
              .catch(error => {
                console.error('编辑轮播图失败:', error)
                this.$message.error('编辑轮播图失败，请稍后重试')
              })
          } else {
            // 添加轮播图
            this.$http.post('/chuanmei/carousel', formData)
              .then(response => {
                if (response.data.success) {
                  this.$message.success('添加成功')
                  this.dialogVisible = false
                  this.loadCarouselList()
                } else {
                  this.$message.error(response.data.message || '添加失败')
                }
              })
              .catch(error => {
                console.error('添加轮播图失败:', error)
                this.$message.error('添加轮播图失败，请稍后重试')
              })
          }
        } else {
          return false
        }
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除这个轮播图吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/chuanmei/carousel/${id}`)
          .then(response => {
            if (response.data.success) {
              this.$message.success('删除成功')
              this.loadCarouselList()
            } else {
              this.$message.error(response.data.message || '删除失败')
            }
          })
          .catch(error => {
            console.error('删除轮播图失败:', error)
            this.$message.error('删除轮播图失败，请稍后重试')
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
.carousel-container {
  max-width: 1200px;
  margin: 0 auto;
}

.card-header {
  margin-bottom: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/Carousel.vue